import { useCallback } from "react";
import { useCurrentSpaceContext } from "@/react/contexts";
import { useAutoadvanceLessonModal } from "../Content/AutoadvanceLessonModal";
import { useCongratulationsModal } from "../Content/CongratulationsModal";
import { useCompleteLessonMutation } from "./useCompleteLessonMutation";
import { useNavigateToNextLesson } from "./useNavigateToNextLesson";

export const useAutocompleteOnFeaturedMediaCompleted = ({
  lesson,
  shouldEnforceFeaturedMediaCompletion,
  isFeaturedMediaCompleted,
  refetchLesson,
}: any) => {
  const { data: space, refetch: refetchSpace } = useCurrentSpaceContext();
  const completeLessonMutation = useCompleteLessonMutation({
    space,
    refetchSpace,
    refetchLesson,
    skipNavigation: true,
  });
  const { navigateToNextLesson, shouldShowCongratulationsModal, nextLesson } =
    useNavigateToNextLesson({
      space,
      refetchSpace,
    });
  const autoadvanceLessonModal = useAutoadvanceLessonModal();
  const congratulationsModal = useCongratulationsModal();

  return useCallback(() => {
    if (
      lesson?.autocomplete_on_featured_media_completion &&
      (!shouldEnforceFeaturedMediaCompletion || isFeaturedMediaCompleted)
    ) {
      if (!lesson.completed) {
        completeLessonMutation.mutate();
      }
      if (nextLesson) {
        void autoadvanceLessonModal.show({
          currentLesson: lesson,
          navigateToNextLesson,
          nextLesson: nextLesson,
        });
      } else if (shouldShowCongratulationsModal) {
        void congratulationsModal.show({ space });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- these are the relevant dependencies
  }, [lesson?.id, isFeaturedMediaCompleted, nextLesson]);
};
